function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "outline",
  "data-name": "Path 268",
  d: "M75.483.5H59.3v42.169H.5v32.32h58.8v33.9H.5v32.32h58.8v40.931h16.183a90.821 90.821 0 000-181.64zm16.135 147V35.146a58.5 58.5 0 010 112.4z",
  fill: "none",
  stroke: "#3c00dc"
});

function SvgEdlOutlinedinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166.805,
    height: 182.643,
    viewBox: "0 0 166.805 182.643"
  }, props), _ref);
}

export default SvgEdlOutlinedinline;